import { flow, map, toPairs, fromPairs, curry } from 'lodash/fp';

export default curry((fn, object) => flow(toPairs, map(fn), fromPairs)(object));
